export default "__VITE_ASSET__Fj33JN53__"